import { useFormat } from '@ideavivat/vivat-2';
import useWithdraw from '@/use/useWithdraw';

const {
  typeClassMap, translateType, statusClassMap, translateStatus,
} = useWithdraw();

export default {
  types: {
    _primaryControls: {
      width: '3rem',
      name: 'เมนู',
    },
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    status: {
      name: 'สถานะ',
      width: '6rem',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => translateStatus(val),
      class: {
        text(val: string, row: { item: { [key: string]: any }; index: number }) {
          return statusClassMap(val);
        },
        cell: 'text-center',
      },
    },
    type: {
      name: 'ประเภท',
      width: '6rem',
      filter: (val: string, row: { item: { [key: string]: any }; index: number }) => translateType(val),
      class: {
        text(val: string, row: { item: { [key: string]: any }; index: number }) {
          return typeClassMap(val);
        },
        cell: 'text-center',
      },
    },
    code: {
      name: 'เลขที่รายการ',
      width: '1fr',
    },
    // dueDate: {
    //   name: 'กำหนดส่ง',
    //   width: '12rem',
    //   // eslint-disable-next-line
    //   filter: (val: string) => val ? useFormat.date(val).displayShortThaiDateTime() : '',
    // },
    creator: {
      name: 'ผู้ทำรายการ',
      width: '10rem',
      style: 'text-right',
      // eslint-disable-next-line
      filter: (val: any) => val?.name || '-',
    },
    created_at: {
      name: 'วันทำรายการ',
      width: '12rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDateTime() : '',
    },
    updated_at: {
      name: 'แก้ไขล่าสุด',
      width: '12rem',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDateTime() : '',
    },
  },

  sortable: [
    'status',
    'type',
    'code',
    'dueDate',
    'user_id',
    'created_at',
    'updated_at',
  ],
};
